import React, { useState } from "react";
import "../styles/InterestRatesPage.css";

/* ══ DATA ══ */

const SAVINGS_ROWS = [
  ["Savings Account – General Public", "2.75%"],
  ["Savings Account – Senior Citizen",  "2.75%"],
  ["Customer With Average Monthly Balance 1 Lakh And Above",  "3.00%"]
];

/* Deposit: each row = [tenor, old-general, old-senior, old-bulk, new-general, new-senior] */
const DEPOSIT_ROWS = [
  ["7 days – 45 days",              "3.50%","4.00%","4.00%", "3.05%","3.55%"],
  ["46 days – 179 days",            "5.50%","6.00%","6.00%", "4.90%","5.40%"],
  ["180 days – 210 days",           "6.00%","6.50%","6.50%", "5.65%","6.15%"],
  ["211 days – less than 1 year",   "6.25%","6.75%","6.75%", "5.90%","6.40%"],
  ["13 months – 24 months",         "6.80%","7.30%","7.30%", "6.80%","7.30%"],
  ["25 months – 36 months",         "7.00%","7.50%","7.50%", "7.00%","7.50%"],
  ["37 months – 60 months",         "6.75%","7.25%","7.25%", "6.30%","6.80%"],
  ["61 months – 120 months",        "6.50%","7.50%","7.50%", "6.05%","7.05%"],
];

const LOAN_SECTIONS = [
  {
    title: "Housing Loan – Category A (Up to ₹10 Lakhs)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL Above 749",  "9.50%"],
      ["CIBIL 700 – 749",  "9.75%"],
      ["CIBIL 650 – 699", "10.00%"],
      ["CIBIL Below 649", "10.50%"],
    ],
  },
  {
    title: "Housing Loan – Category B (Above ₹10L to ₹140L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL Above 749",  "9.50%"],
      ["CIBIL 700 – 749",  "9.75%"],
      ["CIBIL 650 – 699", "10.00%"],
      ["CIBIL Below 649", "10.50%"],
      ["CIBIL Below 599", "11.00%"],
    ],
  },
  {
    title: "Mortgage Loan Against Property",
    col: "CIBIL Score",
    rows: [
      ["CIBIL Above 749", "12.00%"],
      ["CIBIL 700 – 749", "12.25%"],
      ["CIBIL 650 – 699", "12.50%"],
      ["CIBIL 600 – 649", "12.75%"],
      ["CIBIL Below 599", "13.00%"],
    ],
  },
  {
    title: "Unsecured Loan",
    col: "Loan Amount",
    rows: [
      ["Loan up to ₹5 Lakhs", "15.00%"],
    ],
  },
  {
    title: "Vehicle Loan – Category A (Up to ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL Above 749", "12.50%"],
      ["CIBIL 700 – 749", "12.75%"],
      ["CIBIL 650 – 699", "13.00%"],
      ["CIBIL 600 – 649", "13.25%"],
      ["CIBIL Below 599", "13.50%"],
    ],
  },
  {
    title: "Vehicle Loan – Category B (Above ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL Above 749", "12.00%"],
      ["CIBIL 700 – 749", "12.25%"],
      ["CIBIL 650 – 699", "12.50%"],
      ["CIBIL 600 – 649", "12.75%"],
      ["CIBIL Below 599", "13.00%"],
    ],
  },
  {
    title: "Gold Loan",
    col: "Loan Amount",
    rows: [
      ["General Gold Loan ","8.50%"],
      ["Gold Loan for Women's upto 1 Lakh","8.25%"]
    ],
  },
  {
    title: "Business Loan (With Security) – Category A (Up to ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL 700 – 749", "12.75%"],
      ["CIBIL 650 – 699", "13.00%"],
      ["CIBIL 600 – 649", "13.25%"],
      ["CIBIL Below 599", "13.50%"],
    ],
  },
  {
    title: "Business Loan (With Security) – Category B (Above ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL 700 – 749", "12.25%"],
      ["CIBIL 650 – 699", "12.50%"],
      ["CIBIL 600 – 649", "12.75%"],
      ["CIBIL Below 599", "13.00%"],
    ],
  },
  {
    title: "Machinery Loan – Category A (Up to ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL 700 – 749", "12.75%"],
      ["CIBIL 650 – 699", "13.00%"],
      ["CIBIL 600 – 649", "13.25%"],
      ["CIBIL Below 599", "13.50%"],
    ],
  },
  {
    title: "Machinery Loan – Category B (Above ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL 700 – 749", "12.25%"],
      ["CIBIL 650 – 699", "12.50%"],
      ["CIBIL 600 – 649", "12.75%"],
      ["CIBIL Below 599", "13.00%"],
    ],
  },
  {
    title: "Overdraft / Cash Credit – Category A (Up to ₹25L)",
    col: "Category / CIBIL Score",
    rows: [
      ["Against Fixed Deposit",               "1% above FD Rate"],
      ["Against Gold Ornaments – Up to ₹5L",  "8.50%"],
      ["Working Capital (CIBIL Above 749)",    "12.50%"],
      ["CIBIL 700 – 749",                      "12.75%"],
      ["CIBIL 650 – 699",                      "13.00%"],
      ["CIBIL 600 – 649",                      "13.25%"],
      ["CIBIL Below 599",                      "13.50%"],
    ],
  },
  {
    title: "Overdraft / Cash Credit – Category B (Above ₹25L)",
    col: "CIBIL Score",
    rows: [
      ["CIBIL 700 – 749", "12.25%"],
      ["CIBIL 650 – 699", "12.50%"],
      ["CIBIL 600 – 649", "12.75%"],
      ["CIBIL Below 599", "13.00%"],
    ],
  },
];

const TABS = ["Savings", "Deposits", "Loans"];

/* ── Simple table (Savings & Loans) ── */
function SimpleTable({ col1, rows }) {
  return (
    <div className="ir-table-wrap">
      <table className="ir-table">
        <thead>
          <tr>
            <th>{col1}</th>
            <th>Interest Rate</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className={i % 2 === 0 ? "ir-even" : "ir-odd"}>
              <td>{r[0]}</td>
              <td className="ir-rate">{r[1]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ── Deposit comparison table ── */
function DepositTable({ rows }) {
  return (
    <div className="ir-table-wrap">
      <table className="ir-table ir-deposit-table">
        <thead>
          {/* Row 1: main title */}
          <tr>
            <th colSpan={6} className="ir-dep-main-header">
              Fixed Deposits
            </th>
          </tr>
          {/* Row 2: group headers */}
          <tr>
            <th rowSpan={2} className="ir-dep-tenor-header">Tenor</th>
            <th colSpan={3} className="ir-dep-group-header ir-dep-old">
              Existing Interest Rates (w.e.f. 11/06/2024)
            </th>
            <th colSpan={2} className="ir-dep-group-header ir-dep-new">
              Revised Interest Rates (w.e.f. 01/02/2026)
            </th>
          </tr>
          {/* Row 3: sub-column headers */}
          <tr>
            <th className="ir-dep-sub ir-dep-old-sub">General Public</th>
            <th className="ir-dep-sub ir-dep-old-sub">Sr. Citizens</th>
            <th className="ir-dep-sub ir-dep-old-sub">Bulk Deposits<br/><span>(above ₹15 Lakh)</span></th>
            <th className="ir-dep-sub ir-dep-new-sub">General Public</th>
            <th className="ir-dep-sub ir-dep-new-sub">
              Senior Citizen / Co-op Housing Society / Credit Societies (Pathpedi) / Registered Trust / Staff / Ex-Staff
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className={i % 2 === 0 ? "ir-even" : "ir-odd"}>
              <td className="ir-dep-tenor">{r[0]}</td>
              <td className="ir-rate ir-dep-old-cell">{r[1]}</td>
              <td className="ir-rate ir-dep-old-cell">{r[2]}</td>
              <td className="ir-rate ir-dep-old-cell">{r[3]}</td>
              <td className="ir-rate ir-dep-new-cell">{r[4]}</td>
              <td className="ir-rate ir-dep-new-cell">{r[5]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ── MAIN PAGE ── */
export default function InterestRatesPage() {
  const [activeTab, setActiveTab] = useState("Savings");

  return (
    <div className="irates-page">

      {/* HERO */}
      <section className="irates-hero">
        <h1>Interest Rates</h1>
        <p>Current savings, deposit and loan interest rates offered by the bank.</p>
      </section>

      {/* SUMMARY */}
      <section className="irates-summary">
        <div className="irates-summary-card">
          <h3>2.75%</h3>
          <p>Savings Interest</p>
        </div>
        <div className="irates-summary-card">
          <h3>7.50%</h3>
          <p>Max FD Rate</p>
        </div>
        <div className="irates-summary-card">
          <h3>8.50%</h3>
          <p>Gold Loan</p>
        </div>
        <div className="irates-summary-card">
          <h3>9.50%</h3>
          <p>Housing Loan</p>
        </div>
      </section>

      {/* TABS */}
      <div className="ir-tabs-wrap">
        <div className="ir-tabs">
          {TABS.map(tab => (
            <button
              key={tab}
              className={`ir-tab${activeTab === tab ? " ir-tab--active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* TAB CONTENT */}
      <div className="ir-content">

        {/* SAVINGS */}
        {activeTab === "Savings" && (
          <div className="ir-section">
            <h2 className="ir-section-title">Savings Account Interest Rate</h2>
            <SimpleTable col1="Account Type" rows={SAVINGS_ROWS} />
          </div>
        )}

        {/* DEPOSITS */}
        {activeTab === "Deposits" && (
          <div className="ir-section">
            <h2 className="ir-section-title">
              Fixed Deposit Interest Rates
              <span className="ir-shatak-note">
              </span>
            </h2>
            <DepositTable rows={DEPOSIT_ROWS} />
          </div>
        )}

        {/* LOANS */}
        {activeTab === "Loans" && (
          <div className="ir-section">
            <h2 className="ir-section-title">Loan Interest Rates</h2>
            {LOAN_SECTIONS.map((s, idx) => (
              <div key={idx} className="ir-loan-block">
                <h3 className="ir-loan-title">{s.title}</h3>
                <SimpleTable col1={s.col} rows={s.rows} />
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}